module.exports = __webpack_public_path__ + "zvetseni-prsou_10_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_10_before.jpg
// module id = 1294
// module chunks = 0